import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// iter156i: Toasts modernizados — fonte slim (light), rounded 2xl, sombra suave,
// backdrop-blur para look premium. Cores richColors do sonner definidas por tipo
// (success = emerald, error = rose, warning = amber, info = indigo) e reforcadas
// aqui via `data-[type=...]` para override consistente da paleta padrao.
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast font-light tracking-tight rounded-2xl border shadow-xl backdrop-blur-md " +
            "group-[.toaster]:bg-white/95 group-[.toaster]:text-slate-800 group-[.toaster]:border-slate-200 " +
            "data-[type=success]:!bg-emerald-50/95 data-[type=success]:!border-emerald-200 data-[type=success]:!text-emerald-900 " +
            "data-[type=error]:!bg-rose-50/95 data-[type=error]:!border-rose-200 data-[type=error]:!text-rose-900 " +
            "data-[type=warning]:!bg-amber-50/95 data-[type=warning]:!border-amber-200 data-[type=warning]:!text-amber-900 " +
            "data-[type=info]:!bg-indigo-50/95 data-[type=info]:!border-indigo-200 data-[type=info]:!text-indigo-900",
          title: "font-medium tracking-tight leading-snug",
          description: "font-light text-slate-600 leading-relaxed",
          actionButton:
            "group-[.toast]:bg-slate-900 group-[.toast]:text-white group-[.toast]:rounded-lg",
          cancelButton:
            "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-600 group-[.toast]:rounded-lg",
          closeButton:
            "group-[.toast]:bg-white/80 group-[.toast]:border-slate-200 group-[.toast]:hover:bg-slate-50",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
